var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-13" },
    [
      _c("div", { staticClass: "flex pl-6 bg-slate-100 sticky left-88 z-10" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center border-b border-l border-r border-slate-400 bg-pure-white",
            class: { "rounded-bl": _vm.isLast }
          },
          [
            _c(
              "div",
              { staticClass: "px-4 flex flex-shrink-0 gap-2 w-20" },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate text-slate-1000",
                  attrs: { text: _vm.item.id }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "px-4 flex flex-shrink-0 gap-2 w-60 cursor-pointer",
                attrs: { title: _vm.item.name },
                on: {
                  click: function($event) {
                    _vm.panelOpened = true
                  }
                }
              },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate underline",
                  class: _vm.activeProspectStage
                    ? "text-light-purple"
                    : "text-slate-1000",
                  attrs: { text: _vm.item.name }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
        },
        [
          !_vm.item.current_stage_name
            ? _c("BlTextBody2", { attrs: { text: "-" } })
            : _c(
                "div",
                {
                  staticClass: "truncate",
                  attrs: { title: _vm.item.current_stage_name }
                },
                [
                  _c("BlChip", {
                    staticClass: "truncate",
                    attrs: { chip: _vm.item.current_stage_name }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-50 flex items-center gap-2 border-b border-slate-400"
        },
        [
          !_vm.item.assigned_user
            ? _c("BlTextBody2", { attrs: { text: "-" } })
            : _c(
                "div",
                {
                  staticClass:
                    "px-1.5 flex items-center truncate bg-slate-300 rounded"
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "truncate",
                    class: { "italic ": !_vm.item.assigned_user.name },
                    attrs: {
                      title: _vm.item.assigned_user.name || "Deleted user",
                      text: _vm.item.assigned_user.name || "Deleted user"
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableBranch
        ? _c(
            "div",
            {
              staticClass:
                "px-4 flex-shrink-0 bg-pure-white w-50 flex items-center border-b border-slate-400"
            },
            [
              !_vm.item.branch
                ? _c("BlTextBody2", { attrs: { text: "-" } })
                : _c(
                    "div",
                    {
                      staticClass:
                        "h-7 max-w-44 px-2 flex items-center justify-center rounded",
                      style: {
                        backgroundColor:
                          _vm.item.branch.background_color || "unset"
                      },
                      attrs: { title: _vm.item.branch.name }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: { color: _vm.item.branch.color || "unset" },
                        attrs: { text: _vm.item.branch.name || "-" }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-50 flex items-center gap-2 border-b border-slate-400"
        },
        [
          _vm.item.prospect_tags.length === 0
            ? _c("BlTextBody2", { attrs: { text: "-" } })
            : _vm._l(_vm.item.prospect_tags.slice(0, 2), function(tag) {
                return _c(
                  "div",
                  {
                    key: tag.id,
                    staticClass:
                      "h-7 min-w-12 px-2 flex items-center justify-center bg-slate-300 rounded truncate",
                    attrs: { title: tag.name || "-" }
                  },
                  [
                    _c("BlTextBody2", {
                      staticClass: "truncate",
                      attrs: { text: tag.name || "-" }
                    })
                  ],
                  1
                )
              }),
          _vm._v(" "),
          _vm.item.prospect_tags.slice(2).length
            ? _c("div", { staticClass: "relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.openMoreTags = !_vm.openMoreTags
                      }
                    }
                  },
                  [
                    _c("BlBubbleCount", {
                      staticClass: "h-7 hover:bg-light-purple-100",
                      attrs: {
                        count: "+ " + _vm.item.prospect_tags.slice(2).length
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.openMoreTags
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "absolute z-50 mt-10 top-0 right-0 bg-pure-white rounded border border-grey-200 p-1 gap-1 flex flex-col min-w-40 truncate"
                      },
                      _vm._l(_vm.item.prospect_tags.slice(2), function(
                        tag,
                        idx
                      ) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "flex max-w-64" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "px-4 py-2 text-left outline-none rounded truncate",
                                attrs: { title: tag.name || "-" }
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "truncate",
                                  attrs: { text: tag.name || "-" }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.item.prospect_stages, function(stage) {
        return _c(
          "div",
          {
            key: stage.id,
            staticClass:
              "px-4 flex-shrink-0 bg-pure-white w-50 flex items-center border-b border-slate-400",
            attrs: { title: _vm.displayDate(stage.moved_at) }
          },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.displayDate(stage.moved_at) }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-80 flex-grow flex items-center border-b border-slate-400",
          attrs: { title: _vm.reasonForDiscontinuedText }
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate whitespace-pre-line",
            attrs: { text: _vm.reasonForDiscontinuedText }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex pr-6 bg-slate-100 sticky right-0",
          style: { zIndex: 1 }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex-shrink-0 bg-pure-white w-23 flex items-center justify-center border-b border-r border-slate-400",
              class: { "rounded-br": _vm.isLast }
            },
            [
              _c("BlInputButton", {
                attrs: { type: "outlined-error", dense: "", label: "Delete" },
                on: {
                  clicked: function($event) {
                    _vm.deleteOpened = true
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.item.current_prospect_stage_id
        ? _c("ProspectPanel", {
            attrs: {
              location: "table",
              open: _vm.panelOpened,
              id: _vm.item.current_prospect_stage_id
            },
            on: {
              "close-panel": function($event) {
                _vm.panelOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete prospect",
                label: "Delete prospect",
                type: "error",
                disabled: _vm.deleteLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onRemove
              }
            },
            [
              _c("div", { staticClass: "w-160 px-8 flex flex-col gap-4" }, [
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-7 px-1 flex items-center gap-1 rounded bg-tulip-100"
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-6 w-6",
                        attrs: { icon: "user-square", color: "tulip-7" }
                      }),
                      _vm._v(" "),
                      _c("BlTextSubtitle3", {
                        staticClass: "text-tulip-700",
                        attrs: { text: _vm.item.name }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "You're about to delete " }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "font-bold",
                      attrs: { text: _vm.item.name + " " }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "from the pipeline. All data gathered will be permanently lost. Are you sure you want to proceed? This action cannot be undone."
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6c7ab68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6c7ab68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/prospects/Item.vue
// module id = null
// module chunks = 